// extracted by mini-css-extract-plugin
export default {"recordPaymentTabs":"RecordPayment_recordPaymentTabs__LJsZr"};